import { render, staticRenderFns } from "./CustomKeyboard.vue?vue&type=template&id=2ddc430d&scoped=true"
import script from "./CustomKeyboard.vue?vue&type=script&lang=js"
export * from "./CustomKeyboard.vue?vue&type=script&lang=js"
import style0 from "./CustomKeyboard.vue?vue&type=style&index=0&id=2ddc430d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc430d",
  null
  
)

export default component.exports